export class SchoolYearChangedOutsideEvent {
	constructor(public schoolYearID: number) {
	}
}
